/* eslint-disable indent */
/* eslint-disable no-nested-ternary */

import {
  Check,
  CheckCircle,
  Event,
  Today,
} from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import {
  useColorScheme,
  useTheme,
} from '@mui/material/styles';
import {
  changeStatus,
  patchEvent,
} from '@pingum/app-state-management/event/actions';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import Grid from '@mui/material/Grid';
import { groupBy } from 'lodash';
import SelectIcon from '../../../../images/unused-undraw-illustrations/undraw_select_option_re_u4qn.svg';
import ErrorIcon from '../../../../images/unused-undraw-illustrations/undraw_server_down_s-4-lk.svg';
import LoadingTaskRow from './components/LoadingTaskRow';
import styles from './styles';

import buildOverviewGrid, {
  buildOverviewDayTaskData,
  getDaysBetweenDatesObject,
} from './buildOverviewGrid';

import Toolbar from './components/Toolbar';
// setSelectedBarnHorse,
import HorsesCardComponent from '../../../../pages/settings/LocationSettingsPage/locations/components/HorsesCard';
import TagReminderModal from '../../../../pages/settings/TaskPage/reminders/components/TagReminder/components/TagReminderModal';
import { setGlobalModals } from '../../../../redux/app/actions';
import {
  SCHEDULE_MODAL_TYPE,
  SET_GLOABL_MODALS,
  TASK_MODAL_TYPE,
} from '../../../../redux/app/types';
import { getBarnBoardSuggestions } from '../../../../redux/board/actions';
import { SET_BOARD_PLANNING_DAY } from '../../../../redux/board/types';
import { setPlannerGridView } from '../../../../redux/planner/actions';
import { generateBarnBoardSuggestions } from '../../../../utils/barnBoardHelper';
import buildPlannerReminderSuggestions from './plannerReminderSuggestions';
import filterPlannerReminderSuggestions from './plannerReminderFilters';
import usePlannerReminders from './usePlannerReminders';
import { TaskCalendarOverviewHorseRow } from './components/TaskCalenderOverviewHorseRow';
import { TaskCalenderOverviewLocationCell } from './components/TaskCalenderOverviewLocationRow';
// import Horse from '../../../Horse';

const TasksComponent = React.memo(({
  navigate,
  handleRefresh,
  plannerScopeKey,
  // eslint-disable-next-line no-unused-vars
  handleOpenScheduleModal,
  barnTasks,
  horseTasks,
  eventTemplateIds,
  filterTagIds,
  selectedParticipantUser,
  selectedScheduleUser,
  setOpenQuickSelectMenu,
  setSelectedSlot,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  setSlotBarnHorses,
  loadData,
}) => {
  const muiTheme = useTheme();
  const { mode: colorMode = 'light' } = useColorScheme();
  const classes = React.useMemo(
    () => styles(muiTheme, colorMode),
    [muiTheme, colorMode],
  );
  const todayTimestamp = moment().startOf('day').toDate().getTime();
  const endPlanningTimestamp = moment().startOf('day').add(15, 'hour').toDate()
    .getTime();
  const dispatch = useDispatch();
  const fullScreen = useMediaQuery(muiTheme.breakpoints.down('sm'));

  // State
  const [selectedBarnHorses, setSelectedBarnHorses] = React.useState([]);
  const [itemSelectAnchorEl, setItemSelectAnchorEl] = React.useState(null);
  const [openItemSelectMenu, setOpenItemSelectMenu] = React.useState(null);
  const [eventOptions, setEventOptions] = React.useState(null);
  const plannerGridRef = React.useRef(null);
  const initialScrollDone = React.useRef(false);
  const pendingGridScroll = React.useRef(null);
  const refreshBoardRef = React.useRef(handleRefresh);
  refreshBoardRef.current = handleRefresh;
  const [sliceIndex, setSliceIndex] = React.useState(0);
  const [boardSuggestions, setBoardSuggestions] = React.useState({});
  const [selectedReminder, setSelectedReminder] = React.useState(null);
  const [horseLocationsByTag, setHorseLocationsByTag] = React.useState({});
  const [confirmCompleteTasks, setConfirmCompleteTasks] = React.useState(false);
  const [planningMode, setPlanningMode] = React.useState(null);
  const gridView = useSelector((state) => state.planner.gridView || 'week');
  const showReminders = useSelector((state) => state.planner.showReminders !== false);
  const selectedDay = gridView === 'day'
    ? `${moment(startDate).startOf('day').toDate().getTime()}`
    : null;

  React.useEffect(() => {
    if (fullScreen && gridView !== 'day') {
      const todayMoment = moment().startOf('day');
      dispatch(setPlannerGridView('day'));
      setStartDate(todayMoment.toDate());
      setEndDate(todayMoment.clone().endOf('day').toDate());
    }
  }, [dispatch, fullScreen, gridView, setEndDate, setStartDate]);

  React.useEffect(() => {
    dispatch({
      type: SET_GLOABL_MODALS,
      inlineDrawer: !!planningMode,
    })
    dispatch({
      type: SET_BOARD_PLANNING_DAY,
      planningDay: (!!planningMode && selectedDay),
    })
    // togglePlanningMode(planningMode)
  }, [planningMode, selectedDay]);

  // Redux
  const selectedLocation = useSelector((state) => state.location.selectedLocation);
  const eventData = useSelector((state) => state.eventData.eventData);
  const statuses = useSelector((state) => state.status.statuses);
  const isFetchingEventTemplates = useSelector((state) => state.eventTemplate.isFetchingEventTemplates);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const isFetchingBoard = useSelector((state) => state.board.isFetchingBoard);
  const isRefreshingBoard = useSelector((state) => state.board.isRefreshingBoard);
  const refreshErrorMessage = useSelector((state) => state.board.refreshErrorMessage);
  const errorMessage = useSelector((state) => state.board.errorMessage);
  const barnHorses = useSelector((state) => state.board.barnHorses);
  const tasks = useSelector((state) => state.board.tasks);
  const events = useSelector((state) => state.board.events);
  const boardBarnHorses = useSelector((state) => state.board.barnHorses);
  const mappedHorseSuggestions = useSelector((state) => state.board.mappedHorseSuggestions);
  const upcomingDueDates = useSelector((state) => state.board.upcomingDueDates);
  const allHorseLocations = useSelector((state) => state.location.allHorseLocations);
  const isUpdatingEvent = useSelector((state) => state.event.isUpdatingEvent);
  const isChangingStatus = useSelector((state) => state.event.isChangingStatus);
  const contextTimezone = useSelector((state) => state.app.contextTimezone);
  const boardVersion = useSelector((state) => state.board.lastUpdatedDate);
  const overview = React.useMemo(() => buildOverviewGrid(
    selectedLocation,
    barnHorses,
    barnUsersMap,
    events,
    tasks,
    startDate,
    endDate,
    (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTagTypeId) || 0,
    barnHorsesMap,
    selectedBarn.barnMetadata,
    eventData.reduce((map, obj) => {
      const mappedData = map;
      mappedData[obj.id] = obj;
      return mappedData;
    }, {}),
    statuses.filter((s) => s.id !== selectedBarn.barnMetadata.statusStartId
      && s.id !== selectedBarn.barnMetadata.statusPendingId && s.id !== selectedBarn.barnMetadata.statusEndId),
  ), [selectedLocation, barnHorses, barnUsersMap, events, tasks, startDate, endDate,
    barnHorsesMap, selectedBarn.barnMetadata, eventData, statuses]);
  const dayTaskData = React.useMemo(() => buildOverviewDayTaskData(
    startDate,
    endDate,
    events,
    tasks,
  ), [startDate, endDate, events, tasks]);

  const viewScope = JSON.stringify([selectedBarn.id, selectedBarn.tenant, selectedLocation?.id, startDate, endDate,
    eventTemplateIds, filterTagIds, selectedScheduleUser, selectedParticipantUser, plannerScopeKey]);
  const currentViewScope = React.useRef(null);
  if (currentViewScope.current?.key !== viewScope) currentViewScope.current = { key: viewScope };
  const viewSession = currentViewScope.current;
  const mounted = React.useRef(false);
  React.useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);
  const isCurrentView = () => mounted.current && currentViewScope.current === viewSession;
  React.useEffect(() => setSelectedReminder(null), [viewScope]);
  const timezone = selectedLocation?.timezone || contextTimezone || moment.tz.guess();
  const reminderData = usePlannerReminders({
    barn: selectedBarn,
    locationId: selectedLocation?.id,
    barnHorses: boardBarnHorses,
    timezone,
    enabled: showReminders && horseTasks,
    paused: isFetchingBoard || isUpdatingEvent || isChangingStatus,
    refreshKey: JSON.stringify([boardVersion, startDate, endDate, eventTemplateIds, filterTagIds]),
  });
  const selectedTagReminder = selectedReminder?.viewSession === viewSession
    ? reminderData.reminders.find((reminder) => Number(reminder.id) === Number(selectedReminder.reminder.id)) || selectedReminder.reminder
    : null;
  const reminderSuggestions = React.useMemo(() => filterPlannerReminderSuggestions(buildPlannerReminderSuggestions({
    reminders: reminderData.reminders,
    barnHorses: boardBarnHorses,
    overview,
    tasks,
    now: reminderData.now,
    timezone,
    eventTemplateIds,
    filterTagIds,
  }), {
    selectedScheduleUser,
    selectedParticipantUser,
    barnUsersMap,
  }), [reminderData.reminders, reminderData.now, boardBarnHorses, overview, tasks, timezone, eventTemplateIds, filterTagIds,
    selectedScheduleUser, selectedParticipantUser, barnUsersMap]);

  const captureGridScroll = () => {
    const grid = plannerGridRef.current;
    if (grid) {
      pendingGridScroll.current = {
        viewSession,
        left: grid.scrollLeft,
        top: grid.scrollTop,
      };
    }
  };
  const refreshPlanner = (reload = false) => {
    if (reload !== true || !isCurrentView()) return;
    captureGridScroll();
    refreshBoardRef.current(false, { background: true });
  };
  const refreshRemindersAndPlanner = (reload = false) => {
    if (!isCurrentView()) return;
    reminderData.refresh();
    refreshPlanner(reload);
  };

  const handleReminderClick = (suggestion) => {
    setSelectedReminder({
      reminder: suggestion.reminder,
      viewSession,
    });
    reminderData.refresh();
  };

  React.useEffect(() => {
    // Last get any board suggestions
    if (boardBarnHorses && boardBarnHorses.length > 0) {
      dispatch(getBarnBoardSuggestions(boardBarnHorses))
    }
  }, [boardBarnHorses, dispatch])

  React.useEffect(() => {
    if (overview && boardBarnHorses.length > 0
      && Object.keys(overview).length === boardBarnHorses.length + 1) {
      setBoardSuggestions(generateBarnBoardSuggestions(
        barnHorses,
        overview,
        mappedHorseSuggestions || {},
        upcomingDueDates,
        startDate,
        endDate,
      ))
    }
  }, [overview, upcomingDueDates, mappedHorseSuggestions])

  React.useEffect(() => {
    // Used for the schedule button in the filter component so selected horses in grid are passed to schedule modals
    setSlotBarnHorses(selectedBarnHorses);
  }, [selectedBarnHorses])

  React.useLayoutEffect(() => {
    if (isRefreshingBoard && !pendingGridScroll.current) captureGridScroll();
    const scroll = pendingGridScroll.current;
    if (!scroll) return;
    if (scroll.viewSession !== viewSession || refreshErrorMessage) {
      pendingGridScroll.current = null;
    } else if (!isFetchingBoard && plannerGridRef.current) {
      plannerGridRef.current.scrollLeft = scroll.left;
      plannerGridRef.current.scrollTop = scroll.top;
      pendingGridScroll.current = null;
    }
  }, [overview, viewSession, refreshErrorMessage, isFetchingBoard, isRefreshingBoard]);

  React.useEffect(() => {
    if (initialScrollDone.current || isFetchingBoard || isFetchingEventTemplates || selectedDay || !Object.keys(overview).length) return;
    const grid = plannerGridRef.current;
    const todayCell = grid?.querySelector('#scroll-to-today');
    if (grid && todayCell) {
      initialScrollDone.current = true;
      grid.scrollLeft = Math.max(0, todayCell.offsetLeft - (grid.clientWidth - todayCell.offsetWidth) / 2);
    }
  }, [overview, isFetchingBoard, isFetchingEventTemplates, selectedDay]);

  React.useEffect(() => {
    setHorseLocationsByTag(groupBy((allHorseLocations || [])
      .map((hl) => ({
        ...hl,
        tagId: (barnHorsesMap[hl.horse.id] && barnHorsesMap[hl.horse.id][0].pingumTagId) || 0,
      })), 'tagId'))
  }, [allHorseLocations])

  const handleOverviewItemClick = (e, item, openModal = true) => {
    setEventOptions(null);
    setItemSelectAnchorEl(null);
    setOpenItemSelectMenu(false);
    if (item.task) {
      dispatch(setGlobalModals(openModal
        ? TASK_MODAL_TYPE
        : 'unknown', item.task, (item.event && item.event.resource) || null, item.event || null, {}, refreshPlanner));
    } else {
      dispatch(setGlobalModals(openModal
        ? SCHEDULE_MODAL_TYPE
        : 'unknown', null, item.event.resource, item.event, {
        locationId: item.event.eventTask
          ? selectedLocation.id
          : null, // if set, this is a calendar event
        taskTagIds: [],
        eventTemplateTagTypeFilter: -1,
        openInSeries: false,
        startDate: null,
        assignment: selectedScheduleUser,
        rescheduleDate: null,
        drawer: !!(planningMode || selectedDay),
      }, refreshPlanner));
    }
  }

  const handleCalendarEventItemClick = (e, items) => {
    if (items && items.length > 1) {
      setEventOptions(items);
      setItemSelectAnchorEl(e.target);
      setOpenItemSelectMenu(true);
    } else if (items.length === 1) {
      handleOverviewItemClick(e, items[0])
    }
  }

  const handleOverviewItemTaskStateChangeClick = (item, callBackOnDone) => {
    if (!item || !item.task) {
      console.error('Selected task item is not valid. No task found');
      return;
    }
    if (item.task.completeDate) {
      // reactivate
      dispatch(patchEvent(item.task.id, { completeEvent: false })).then(() => {
        dispatch(changeStatus(
          item.task.id,
          {
            statusId: parseInt(selectedBarn.barnMetadata.statusPendingId, 10),
            statusComment: null,
            completeEvent: false,
            assignment: (item.task.currentEventStatus && item.task.currentEventStatus.assignment) || '',
          },
          () => {
            setTimeout(() => {
              callBackOnDone();
            }, 500); // small delay for animation
          },
        ));
      });
    } else {
      // complete
      dispatch(changeStatus(
        item.task.id,
        {
          statusId: parseInt(selectedBarn.barnMetadata.statusEndId, 10),
          statusComment: 'Task marked complete',
          completeEvent: true,
          assignment: (item.task.currentEventStatus && item.task.currentEventStatus.assignment) || '',
        },
        () => {
          setTimeout(() => {
            callBackOnDone();
          }, 500); // small delay for animation
        },
      ));
    }
  }

  const actionCompleteCallback = () => {
    setSelectedBarnHorses([]);
  }

  const handleCompleteTasks = (dayKey) => {
    // get all active and incomplete tasks for day
    const { incompleteTasks } = dayTaskData[dayKey];
    for (let i = 0; i < incompleteTasks.length; i += 1) {
      handleOverviewItemTaskStateChangeClick({ task: incompleteTasks[i] }, () => { });
      // TODO make this better or add new API to bulk complete, for now adding small delay every 5 tasks
      if (i % 5 === 0) {
        setTimeout(() => {

        }, 500)
      }
    }
    setTimeout(() => {
      setConfirmCompleteTasks(false);
    }, 1100)
  }

  const isLoading = ((isFetchingBoard && !isRefreshingBoard) || isFetchingEventTemplates);
  const showLocationRow = barnTasks;
  return (
    <Box
      sx={{
        px: 2,
        pt: 2,
      }}
    >
      {
        !planningMode && (
          <Toolbar
            gridView={gridView}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            navigate={navigate}
          />
        )
      }
      {reminderData.loading && <Typography variant="caption" color="text.secondary" role="status">Checking horse reminders…</Typography>}
      {reminderData.error && (
        <Alert severity="warning" action={<Button onClick={reminderData.refresh}>Retry</Button>} sx={{ mb: 1 }}>
          Horse reminder suggestions could not be loaded.
        </Alert>
      )}
      {refreshErrorMessage && (
        <Alert severity="warning" action={<Button onClick={() => refreshRemindersAndPlanner(true)}>Retry</Button>} sx={{ mb: 1 }}>
          The planner could not refresh. Your previous view is still shown.
        </Alert>
      )}
      {
        !isLoading && errorMessage && (
          <Box
            sx={{
              margin: 'auto',
              p: 2,
              textAlign: 'center',
            }}
          >
            <Typography variant="h3" align="center" color="error" component="div" sx={{ m: 4 }}>
              Oops... There Was An Error!
            </Typography>
            <Typography align="center" component="div" sx={{ m: 4 }}>
              {errorMessage || 'Error'}
            </Typography>
            <img
              src={ErrorIcon}
              alt="issue with server"
              style={{
                width: 250,
                display: 'block',
                margin: 'auto',
                marginBottom: '1rem',
              }}
            />
          </Box>
        )
      }
      {
        (!isLoading && !errorMessage && !selectedLocation && !selectedLocation.id) && (
          <Box
            sx={{
              margin: 'auto',
              p: 2,
              textAlign: 'center',
            }}
          >
            <Typography variant="captions" align="center" component="div" sx={{ m: 4 }}>
              Select a location to view task overview
            </Typography>
            <img
              src={SelectIcon}
              alt="man selecting something"
              style={{
                width: 250,
                display: 'block',
                margin: 'auto',
                marginBottom: '1rem',
              }}
            />
          </Box>
        )
      }
      {
        (!errorMessage && selectedLocation && selectedLocation.id) && (
          <Grid container spacing={4}>
            <Grid
              sx={{
                display: 'flex',
                gap: 4,
              }}
              size={12}
            >
              <Paper
                sx={{
                  ...classes.paperRoot,
                  flex: 1,
                }}
              >
                <TableContainer
                  ref={plannerGridRef}
                  sx={{
                    maxHeight: `calc(100vh - ${planningMode
                      ? 130
                      : 250}px)`,
                  }}
                >
                  <Table size="small" stickyHeader sx={classes.table}>
                    <TableHead>
                      <TableRow>
                        {!fullScreen && (
                          <TableCell varient="head" sx={classes.cellHeadStickyNarrow} />
                        )}
                        <TableCell
                          varient="head"
                          sx={[classes.cellHeadSticky, fullScreen && {
                            minWidth: '90px !important',
                            maxWidth: '90px !important',
                            width: '90px !important',
                            left: '0 !important',
                          }]}
                        >
                          <HorsesCardComponent
                            location={selectedLocation}
                            onlyButton
                            variant="text"
                            icon
                            onHorsesAdded={() => {
                              setTimeout(() => {
                                loadData(true)
                              }, 500)
                            }}
                          />
                        </TableCell>
                        {
                          Object.keys(getDaysBetweenDatesObject(moment(startDate), moment(endDate)))
                            .filter((day) => !selectedDay || day === selectedDay).map((key) => (
                              <TableCell
                                id={key.toString() === todayTimestamp.toString()
                                  ? 'scroll-to-today'
                                  : null}
                                sx={(key.toString() === todayTimestamp.toString()
                                  ? classes.cellHeadHighlight
                                  : classes.cellHead)}
                                varient="head"
                                key={`table-head-${key}`}
                                onClick={() => {
                                  if (gridView !== 'day') {
                                    dispatch(setPlannerGridView('day'));
                                    setStartDate(moment(parseInt(key, 10)).startOf('day').toDate());
                                    setEndDate(moment(parseInt(key, 10)).endOf('day').toDate());
                                  } else {
                                    dispatch(setPlannerGridView('week'));
                                    setStartDate(moment(startDate).startOf('week').toDate());
                                    setEndDate(moment(startDate).endOf('week').toDate());
                                  }
                                }}
                              >
                                <Grid container spacing={1} alignItems="center">
                                  {
                                    key.toString() === todayTimestamp.toString() && (
                                      <Grid>
                                        <Tooltip title="Today">
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: 0.5,
                                              flexWrap: 'wrap',
                                            }}
                                          >
                                            <Today />
                                            <Chip
                                              label="Today"
                                              size="small"
                                              color="secondary"
                                              sx={{ fontWeight: 700 }}
                                            />
                                          </Box>
                                        </Tooltip>

                                      </Grid>
                                    )
                                  }
                                  <Grid sx={{ margin: 'auto' }}>
                                    <Box>{moment(parseInt(key, 10)).format('ddd MMM Do')}</Box>
                                    {
                                      (!(parseInt(key, 10) > todayTimestamp
                                        || (parseInt(key, 10) === todayTimestamp && new Date().getTime() < endPlanningTimestamp)))
                                      && (!confirmCompleteTasks || confirmCompleteTasks === key) && (
                                        <Box>
                                          {
                                            dayTaskData[key] && dayTaskData[key].incompleteTasks.length > 0 && (
                                              <Tooltip title="Mark all incomplete Tasks as Completed?">
                                                <Chip
                                                  size="small"
                                                  variant="outlined"
                                                  color={confirmCompleteTasks
                                                    ? 'warning'
                                                    : parseInt(key, 10) === todayTimestamp
                                                      ? 'secondary'
                                                      : 'primary'}
                                                  label={confirmCompleteTasks
                                                    ? (`Confirm Complete ${dayTaskData[key].incompleteTasks.length} Task${dayTaskData[key].incompleteTasks.length > 1
                                                      ? 's'
                                                      : ''}?`)
                                                    : `${dayTaskData[key].incompleteTasks.length} Incomplete Task${dayTaskData[key].incompleteTasks.length > 1
                                                      ? 's'
                                                      : ''}`}
                                                  deleteIcon={
                                                    (isUpdatingEvent || isChangingStatus)
                                                      ? <CircularProgress size={18} />
                                                      : (
                                                        confirmCompleteTasks
                                                          ? <CheckCircle color="success" />
                                                          : <Check color="success" />)
                                                  }
                                                  onDelete={(e) => {
                                                    e.stopPropagation();
                                                    if (!confirmCompleteTasks) {
                                                      setConfirmCompleteTasks(key)
                                                    } else {
                                                      handleCompleteTasks(key)
                                                    }
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (!confirmCompleteTasks) {
                                                      setConfirmCompleteTasks(key)
                                                    } else {
                                                      handleCompleteTasks(key)
                                                    }
                                                  }}
                                                />
                                              </Tooltip>
                                            )
                                          }
                                        </Box>
                                      )
                                    }
                                  </Grid>
                                  <Grid>
                                    {
                                      !fullScreen && (
                                        (parseInt(key, 10) > todayTimestamp
                                          || (parseInt(key, 10) === todayTimestamp && new Date().getTime() < endPlanningTimestamp))
                                        && (
                                          <Tooltip
                                            title={planningMode
                                              ? 'Exit Planning Mode'
                                              : 'Enter Planning Mode for this Day'}
                                          >
                                            <Chip
                                              variant="outlined"
                                              sx={[parseInt(key, 10) === todayTimestamp
                                                ? { color: 'white' }
                                                : { color: null }]}
                                              label={!planningMode
                                                ? 'Plan Day'
                                                : 'Stop Planning'}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                if (planningMode) {
                                                  dispatch(setPlannerGridView('week'));
                                                  setStartDate(moment(startDate).startOf('week').toDate());
                                                  setEndDate(moment(startDate).endOf('week').toDate());
                                                } else {
                                                  dispatch(setPlannerGridView('day'));
                                                  setStartDate(moment(parseInt(key, 10)).startOf('day').toDate());
                                                  setEndDate(moment(parseInt(key, 10)).endOf('day').toDate());
                                                }
                                                setPlanningMode(!planningMode);
                                              }}
                                            />
                                          </Tooltip>
                                        )
                                      )
                                    }
                                  </Grid>
                                </Grid>
                              </TableCell>
                            ))
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        isLoading && [1, 2, 3, 4, 5].map((item) => (
                          <LoadingTaskRow
                            key={`loading-item-${item}`}
                            classes={classes}
                            columns={gridView === 'day'
                              ? 2
                              : 8}
                          />
                        ))
                      }
                      {
                        showLocationRow && !isLoading && overview[selectedLocation.pingumTagId] && (
                          <TaskCalenderOverviewLocationCell
                            barnHorses={barnHorses}
                            barnHorsesMap={barnHorsesMap}
                            classes={classes}
                            fullScreen={fullScreen}
                            handleCalendarEventItemClick={handleCalendarEventItemClick}
                            handleOverviewItemClick={handleOverviewItemClick}
                            handleOverviewItemTaskStateChangeClick={handleOverviewItemTaskStateChangeClick}
                            overview={overview}
                            selectedBarnHorses={selectedBarnHorses}
                            selectedDay={selectedDay}
                            selectedLocation={selectedLocation}
                            setOpenQuickSelectMenu={setOpenQuickSelectMenu}
                            setSelectedBarnHorses={setSelectedBarnHorses}
                            setSelectedSlot={(slot) => setSelectedSlot({
                              ...slot,
                              drawer: !!planningMode,
                            })}
                            todayTimestamp={todayTimestamp}
                          />

                        )
                      }

                      {
                        !isLoading && (Object.keys(overview)
                          .filter((key) => key !== selectedLocation.pingumTagId)
                          .sort((keyA, keyB) => -(barnHorsesMap[keyB]
                            ? barnHorsesMap[keyB][0].horse.name
                            : 'zz').localeCompare((barnHorsesMap[keyA]
                              ? barnHorsesMap[keyA][0].horse.name
                              : 'zz'))).slice(sliceIndex * 100, (sliceIndex + 1) * 100)
                          .map((key) => {
                            const barnHorse = barnHorsesMap[key]
                              ? barnHorsesMap[key][0]
                              : {
                                id: -1,
                                horse: {
                                  name: 'Unknown',
                                  picture: null,
                                },
                              };
                            return (
                              <TaskCalendarOverviewHorseRow
                                key={`overview-row-${barnHorse.id}`}
                                actionCompleteCallback={actionCompleteCallback}
                                barnHorse={barnHorse}
                                boardSuggestionsKey={boardSuggestions[key]}
                                reminderSuggestions={reminderSuggestions[key]}
                                onReminderClick={handleReminderClick}
                                classes={classes}
                                dispatch={dispatch}
                                fullScreen={fullScreen}
                                handleCalendarEventItemClick={handleCalendarEventItemClick}
                                handleOverviewItemClick={handleOverviewItemClick}
                                handleOverviewItemTaskStateChangeClick={handleOverviewItemTaskStateChangeClick}
                                navigate={navigate}
                                overviewKey={overview[key]}
                                selectedBarnHorses={selectedBarnHorses}
                                selectedDay={selectedDay}
                                selectedLocation={selectedLocation}
                                setOpenQuickSelectMenu={setOpenQuickSelectMenu}
                                setSelectedBarnHorses={setSelectedBarnHorses}
                                setSelectedSlot={(slot) => setSelectedSlot({
                                  ...slot,
                                  restOfSuggestions: Object.keys(boardSuggestions)
                                    .filter((horseId) => horseId !== 'hasSuggestions' && !slot.barnHorses.find((s) => s.pingumTagId === horseId))
                                    .map((k) => ({
                                      barnHorse: boardSuggestions[k].barnHorse,
                                      allSuggestions: (boardSuggestions[k][slot.dayOfWeek] && boardSuggestions[k][slot.dayOfWeek].allSuggestions)
                                        || [],
                                    })),
                                  drawer: !!planningMode,
                                })}
                                theme={muiTheme}
                                todayTimestamp={todayTimestamp}
                                locations={horseLocationsByTag[barnHorse.pingumTagId] || []}
                                planningMode={planningMode}
                                handleOpenScheduleModal={(et, isCalendarEvent, slot) => {
                                  handleOpenScheduleModal(et, isCalendarEvent, {
                                    ...slot,
                                    restOfSuggestions: Object.keys(boardSuggestions)
                                      .filter((horseId) => horseId !== 'hasSuggestions' && !slot.barnHorses.find((s) => s.pingumTagId === horseId))
                                      .map((k) => ({
                                        barnHorse: boardSuggestions[k].barnHorse,
                                        allSuggestions: (boardSuggestions[k][slot.dayOfWeek] && boardSuggestions[k][slot.dayOfWeek].allSuggestions)
                                          || [],
                                      })),
                                    drawer: !!planningMode,
                                  })
                                }}
                              />

                            )
                          }))
                      }
                    </TableBody>
                  </Table>
                  {Object.keys(overview).filter((key) => key !== selectedLocation.pingumTagId).length > 100 && (
                    <Box sx={{ m: 2 }}>
                      <Pagination
                        count={parseInt(Math.ceil(Object.keys(overview)
                          .filter((key) => key !== selectedLocation.pingumTagId).length / 100), 10)}
                        variant="outlined"
                        page={sliceIndex + 1}
                        onChange={(event, value) => { setSliceIndex(value - 1); }}
                      />
                      <Typography variant="subtitle1" align="center" component="div" sx={{ mt: 4 }}>
                        This location has a lot of horses. Consider placing your horses into smaller groups by barn &ldquo;location&rdquo; or
                        other criteria (trainers, teams, etc) to make it easier to plan with a smaller and similar subset of horses.
                      </Typography>
                    </Box>
                  )}
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        )
      }
      <Menu
        id="item-select-menu"
        anchorEl={itemSelectAnchorEl}
        open={!!openItemSelectMenu}
        onClose={() => { setOpenItemSelectMenu(false); setItemSelectAnchorEl(null); setEventOptions(null); }}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
        PaperProps={{
          style: {
            maxHeight: 100 * 4.5,
            width: '4000',
          },
        }}
      >
        {
          (eventOptions && eventOptions.length > 1) && (
            eventOptions.sort((a, b) => a.sortDateTimestamp - b.sortDateTimestamp).map((item) => (
              <MenuItem key={`item-option-select-${item.id}`} onClick={(e) => { handleOverviewItemClick(e, item); }}>
                <Event color="secondary" fontSize="small" sx={{ mr: 1 }} />{moment(item.event.start).format('h:mm a')}  {item.name}
              </MenuItem>
            ))
          )
        }
      </Menu>
      {
        !!selectedTagReminder && (
          <TagReminderModal
            tagReminder={selectedTagReminder}
            open={!!selectedTagReminder}
            zIndex={muiTheme.zIndex.modal - 1}
            onClose={() => setSelectedReminder(null)}
            triggerDataRefresh={refreshRemindersAndPlanner}
            onEditorRefresh={(reload) => {
              if (reload === true) refreshRemindersAndPlanner(true);
            }}
          />
        )
      }
    </Box>
  );
});

TasksComponent.propTypes = {
  navigate: PropTypes.func.isRequired,
  handleOpenScheduleModal: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  plannerScopeKey: PropTypes.string,
  barnTasks: PropTypes.bool,
  horseTasks: PropTypes.bool,
  eventTemplateIds: PropTypes.array,
  filterTagIds: PropTypes.array,
  selectedParticipantUser: PropTypes.object,
  selectedScheduleUser: PropTypes.object,
  setOpenQuickSelectMenu: PropTypes.func.isRequired,
  setSelectedSlot: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  startDate: PropTypes.any.isRequired,
  endDate: PropTypes.any.isRequired,
  setSlotBarnHorses: PropTypes.func.isRequired,
  loadData: PropTypes.func.isRequired,
};
TasksComponent.defaultProps = {
  plannerScopeKey: null,
  barnTasks: true,
  horseTasks: true,
  eventTemplateIds: [],
  filterTagIds: [],
  selectedParticipantUser: null,
  selectedScheduleUser: null,
};

export default TasksComponent;
